import { computed, ref, toRefs, unref } from 'vue'

import { GaImageResponsive } from '../image-responsive'

import { useScrollable } from './scripts/composables'
import { SIZE_DOTS } from './scripts/consts'

// @vue/component
export default {
  name: 'ga-touch-slider',

  components: {
    GaImageResponsive,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    sizeDots: {
      type: String,
      default: SIZE_DOTS.XXS,
    },
    maxCount: {
      type: Number,
      default: 10,
    },
  },

  setup(props) {
    const rootRef = ref(null)
    const activeIndex = ref(0)
    const { items, maxCount } = toRefs(props)

    const itemsInternal = computed(() =>
      unref(items).length > unref(maxCount)
        ? unref(items).slice(0, unref(maxCount))
        : unref(items),
    )

    const onScroll = ({ target }) => {
      const { clientWidth, scrollLeft } = target

      activeIndex.value = Math.round(Math.abs(scrollLeft / clientWidth))
    }

    const { scrollable } = useScrollable(rootRef)

    const mods = computed(() => ({
      scrollable: unref(scrollable),
    }))

    return {
      mods,
      rootRef,
      onScroll,
      activeIndex,
      itemsInternal,
    }
  },
}
